import React, { Fragment } from "react";
import { Col, Row } from "reactstrap";
import { Icons } from "../components/UI/Icon/Icon";
import { showToast } from "../utils/helper";

export const IconsPage = () => {
  const iconKeys = Object.keys(Icons);

  const handleCopyToClipboard = (iconName) => {
    const iconUsage = `<Icons.${iconName} size="md" />`;
    navigator.clipboard
      .writeText(iconUsage)
      .then(() => {
        // alert(`Copied to clipboard: ${iconUsage}`);
        showToast(`Copied to clipboard: ${iconUsage}`);
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };

  return (
    <div style={{ padding: 24 }}>
      <Row>
        {iconKeys.map((key) => {
          const IconComponent = Icons[key];
          return (
            <Col key={key} xs="6" sm="4" md="3" lg="2">
              <div
                onClick={() => handleCopyToClipboard(key)}
                style={{
                  textAlign: "center",
                  marginBottom: "20px",
                  boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                  padding: 16,
                  borderRadius: 8,
                }}
              >
                <span>{key}</span>
                <div>
                  <IconComponent size="md" />
                </div>
              </div>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default IconsPage;
